import React from 'react';

export type SpinnerProps = {
  size?: 'small' | 'medium';
};

export const Spinner = ({ size = 'medium' }: SpinnerProps) => {
  return (
  <div className={`flowingly-spinner ${size}`}>
      <div className="spinner-bar"></div>
      <div className="spinner-bar"></div>
      <div className="spinner-bar"></div>
      <div className="spinner-bar"></div>
      <div className="spinner-bar"></div>
      <div className="spinner-bar"></div>
      <div className="spinner-bar"></div>
      <div className="spinner-bar"></div>
      <div className="spinner-bar"></div>
      <div className="spinner-bar"></div>
      <div className="spinner-bar"></div>
      <div className="spinner-bar"></div>
    </div>
  );
};
